import { LicenseInfo } from '@mui/x-license-pro'

const muiLicenseKey =
  import.meta.env.VITE_MUI_X_LICENSE_KEY ||
  import.meta.env.REACT_APP_MUI_X_LICENSE_KEY ||
  ''

export const hasMuiXLicense = Boolean(muiLicenseKey)

// Set the license key for MUI X Pro components
if (muiLicenseKey) {
  LicenseInfo.setLicenseKey(muiLicenseKey)
}

// Debug logging in development
if (import.meta.env.VITE_ENVIRONMENT === 'development') {
  console.log('[MUI License] Check:', {
    hasViteKey: Boolean(import.meta.env.VITE_MUI_X_LICENSE_KEY),
    hasReactAppKey: Boolean(import.meta.env.REACT_APP_MUI_X_LICENSE_KEY),
    hasLicense: hasMuiXLicense,
    licenseKeyLength: muiLicenseKey?.length || 0,
    licenseSet: Boolean(muiLicenseKey)
  })
}
